<template>
  <section ref="form" class="v-action-form d-flex justify-center">
    <form-inner
      v-if="formConfig"
      :key="action_id"
      :form-style="formStyle"
      :fundraiser-initial-form-style="fundraiserInitialFormStyle"
    />
  </section>
</template>

<script>
import Vue from 'vue'
import VueNativeSock from 'vue-native-websocket'
import { mapState } from 'vuex'

import store from '../store'
import FormInner from './components/FormInner.vue'
import { getWebSocketUrl } from './utils/websockets'

export default {
  name: 'ActionForm',
  components: {
    FormInner
  },
  props: {
    // eslint-disable-next-line vue/prop-name-casing
    action_id: {
      type: String,
      required: true
    },
    formStyle: {
      type: Object,
      required: false,
      default: () => ({})
    },
    fundraiserInitialFormStyle: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  computed: {
    messageQueue() {
      return this.socket.messages
    },
    ...mapState('actionForm', ['formConfig', 'socket'])
  },
  watch: {},
  created() {
    this.$store.commit(
      'actionForm/SET_BASE_URL',
      process.env.petitionsBaseUrl || process.env.PETITIONS_BASE_DOMAIN || ''
    )
    this.$store.commit('actionForm/SET_ACTION_ID', this.action_id)
  },
  async mounted() {
    this.$store.commit('actionForm/SET_GET_CLIENT_RECT', this.getClientRect)
    this.$store.commit('actionForm/SET_DOLLAR_GTAG', this.$gtag)
    this.$store.commit('actionForm/SET_DOLLAR_GTM', this.$gtm)

    // fetchFormConfig is also called server side in nuxt, but we need to also call it client side
    // for the geo location to work, or, if this form is not running in nuxt. Ie its running with
    // Django.
    await this.$store.dispatch('actionForm/fetchFormConfig').then(() => {
      // Check for any preselected amounts in the query params
      const params = new URLSearchParams(window.location.search)
      const preselectedOneOffDonation = params.get('donation_oneoff')
      const preselectedMonthlyDonation = params.get('donation_monthly')

      // If there are preselected amount query params, set those in the form
      if (preselectedOneOffDonation) {
        this.$store.commit('actionForm/SET_PRESELECTED_ONEOFF_AMOUNT', preselectedOneOffDonation)
        this.$store.dispatch('actionForm/updatePaymentFrequency', {
          selectedPaymentFrequency: 'one_time'
        })
      }
      if (preselectedMonthlyDonation) {
        this.$store.commit('actionForm/SET_PRESELECTED_MONTHLY_AMOUNT', preselectedMonthlyDonation)
        this.$store.dispatch('actionForm/updatePaymentFrequency', {
          selectedPaymentFrequency: 'monthly'
        })
      }
    })
    // Only run fetchUserData after fetchFormConfig has returned
    this.$store.dispatch('actionForm/fetchUserData')

    const format = 'json'

    // Initialise the ActionForm websocket
    Vue.use(VueNativeSock, getWebSocketUrl(this.action_id), {
      reconnection: true, // (Boolean) whether to reconnect automatically (false)
      reconnectionAttempts: 5, // (Number) number of reconnection attempts before giving up (Infinity),
      reconnectionDelay: 3000, // (Number) how long to initially wait before reconnecting (1000)
      format,
      store,
      passToStoreHandler: (eventName, event) => {
        if (!eventName.startsWith('SOCKET_')) {
          return
        }
        let method = 'commit'
        let target = eventName.toUpperCase()
        let msg = event

        if (format === 'json' && event.data) {
          msg = JSON.parse(event.data)
          if (msg.mutation) {
            target = [msg.namespace || '', msg.mutation].filter(e => !!e).join('/')
          } else if (msg.action) {
            method = 'dispatch'
            target = [msg.namespace || '', msg.action].filter(e => !!e).join('/')
          }
        }
        this.$store[method](`actionForm/${target}`, msg)
      }
    })
  },
  methods: {
    getClientRect() {
      return this.$refs.form.getBoundingClientRect()
    }
  }
}
</script>

<style lang="scss">
.h-100 {
  height: 100%;
}
.w-100 {
  width: 100%;
}
.monospace {
  font-family: monospace;
}
</style>
